import React from "react";
import { Typography } from "@material-ui/core";
import useNotesContext from "../../../hooks/useNotesContext";
import { useStyles } from "./PinnedNotes.styles";


const MAX_DISPLAY_LENGTH = 100;

const PinnedNote = () => {
  const classes = useStyles();
  const { notes } = useNotesContext();
  const pinnedNote = notes.find((n) => n.pinned);

  if (!pinnedNote) return null;

  const displayText = pinnedNote.noteText.length > MAX_DISPLAY_LENGTH
    ? pinnedNote.noteText.slice(0, MAX_DISPLAY_LENGTH) + "..."
    : pinnedNote.noteText;

  return (
    <div className={classes.container}>
      <Typography variant="body1" className={classes.header}>
          Note
      </Typography>
      <div className={classes.root} data-testid="pinned-note">
        
        <Typography variant="body2"className={classes.text}>
          {displayText}
        </Typography>
      </div>
    </div>
  );
};

export default PinnedNote;
